import { BasicControls } from "./basic-controls/basic-controls";
import { Timeline } from "./timeline";

export function PlaybackControls() {
  return (
    <div className="w-full h-full border-top shadow-sidebar disable-overscroll">
      <BasicControls />
      <Timeline />
    </div>
  );
}
